import BaseQuery from "@/stateManagement/BaseQuery";
import { singleton } from "tsyringe";

import GiftRegistryStore, {
    GiftRegistryState,
} from "../stores/GiftRegistryStore";

@singleton()
class GiftRegistryQuery extends BaseQuery<GiftRegistryState> {
    constructor(store: GiftRegistryStore) {
        super(store);
    }

    registries$ = this.select((state) => state.registries);
    registryTypes$ = this.select((state) => state.registryTypes);
    sharedRegistry$ = this.select((state) => state.sharedRegistry);
    customerAddresses$ = this.select((state) => state.customerAddresses);
    status$ = this.selectStatus();
    sharingStatus$ = this.select((state) => state.sharingStatus);
    changeRegistryStatus$ = this.select((state) => state.changeRegistryStatus);
    customerAddressesStatus$ = this.select(
        (state) => state.customerAddressesStatus
    );
    loadMoreStatus$ = this.select((state) => state.loadMoreStatus);
    error$ = this.selectError();

    public selectItemInRegistry(
        productId: number | null,
        variantId: number | null,
        registryId: number
    ) {
        return this.select((state) => {
            if (!productId || !variantId) return;

            const registry = state.registries.find(
                (registry) => registry.id === registryId
            );

            return registry?.items.find(
                (item) =>
                    item.productId === productId && item.variantId === variantId
            );
        });
    }

    public selectIsItemLoadingInRegistry(
        productId: number | null,
        registryId: number
    ) {
        return this.select((state) => {
            if (!productId) return false;
            const productArr =
                state.itemsLoadingInRegistriesStatuses[productId];

            if (!productArr) return false;
            return productArr.some((_registryId) => _registryId === registryId);
        });
    }

    public selectVariantExistsInRegistries(
        productId: number | null,
        variantId: number | null
    ) {
        return this.select(({ registries }) => {
            if (!productId || !variantId) return false;

            return registries.some((registry) =>
                registry.items.some(
                    (item) =>
                        item.productId === productId &&
                        item.variantId === variantId
                )
            );
        });
    }
}

export default GiftRegistryQuery;
